import { render, staticRenderFns } from "./printinvoice.vue?vue&type=template&id=d6805e50&scoped=true&"
import script from "./printinvoice.vue?vue&type=script&lang=js&"
export * from "./printinvoice.vue?vue&type=script&lang=js&"
import style0 from "./printinvoice.vue?vue&type=style&index=0&id=d6805e50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6805e50",
  null
  
)

export default component.exports